import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import _ from 'lodash';
import { useSnapshot, subscribe } from 'valtio';
import { Card, CardHeader, CardBody, TabPane, Row, Col } from 'reactstrap';
import PageTabs from 'components/PageTabs';
import { getPortfolioAnalysisCompareAnalyze } from 'services/analysis';
import TightTable from 'components/TightTable';
import TimePeriod, { formatDates } from 'components/TimePeriod';
import { FixedCenterLoader } from 'components/Loaders';
import BackButton from 'views/portfolio-analysis/BackButton';
import Assumptions from './Assumptions';
import SummaryHoldings from './Holdings';
import SummarySummary from './Summary';
import { optimizationState } from '../state';
import { prepareData, parseParams } from 'views/portfolio-analysis/helpers';
import { toDeci, toDeciTable, toPercTable, formatCurrency, tablePresets } from 'helpers/formatter';

function HeaderComponent({ content }) {
  if (!content) return;

  return (
    <Card>
      <CardHeader tag="h4" className="mt-0 tw-text-center">
        Description
      </CardHeader>
      <CardBody>
        <div className="tw-italic tw-text-sm tw-text-center">{content}</div>
      </CardBody>
    </Card>
  );
}

function FooterComponent({ content }) {
  if (!content) return;

  return (
    <Card>
      <CardHeader tag="h4" className="mt-0 tw-text-center">
        Notes
      </CardHeader>
      <CardBody>
        <div className="tw-italic tw-text-sm tw-text-center">{content}</div>
      </CardBody>
    </Card>
  );
}

function PortfolioOptimizationResult({ notify, session }) {
  const snap = useSnapshot(optimizationState);
  const navigate = useNavigate();

  if (_.isEmpty(snap.result)) {
    navigate('/portfolio-optimization-build', { replace: false });
    return;
  }

  const result = snap.result;
  const params = { benchmark: snap.benchmark };
  console.log('result', result);
  return (
    <>
      {/* <div>
        <BackButton />
      </div> */}

      <div className="tw-flex tw-justify-center tw-items-center">
        <div className="tw-mx-auto">
          <h3 className="title tw-mb-2">Portfolio Optimization</h3>
        </div>
      </div>

      <PageTabs
        options={[
          { value: 'assumptions', label: 'Assumptions' },
          { value: 'summary', label: 'Summary' },
        ]}
        colorIndex={0}
        round={false}
      >
        <TabPane tabId="assumptions" role="tabpanel">
          <HeaderComponent content={result.descriptions?.assumptions} />
          <Assumptions data={result.descriptions} />
          <FooterComponent content={result.notes?.assumptions} />
        </TabPane>
        <TabPane tabId="summary" role="tabpanel">
          <HeaderComponent content={result.descriptions?.summary} />
          <PageTabs
            options={[
              { value: 'holdings', label: 'Holdings' },
              { value: 'summary', label: 'Summary' },
            ]}
            colorIndex={1}
          >
            <TabPane tabId="holdings" role="tabpanel">
              <SummaryHoldings
                data={result.output_page.details_page}
                params={params}
                notify={notify}
                session={session}
              />
            </TabPane>
            <TabPane tabId="summary" role="tabpanel">
              <SummarySummary data={result.output_page.summary} params={params} notify={notify} session={session} />
            </TabPane>
          </PageTabs>
          <FooterComponent content={result.notes?.summary} />
        </TabPane>
      </PageTabs>
    </>
  );
}

export default PortfolioOptimizationResult;
